export default __webpack_public_path__ + "static/media/Method-level_documentation.02c47264.jpg";